let AdrConstants = {
    // ADR option types
    ADR_HK: 'HK',
    ADR_HK10: 'HK10',
    ADR_HK20: 'HK20',
    ADR_SEA: 'SEA',
    ADR_PHTH: 'PHTH',
    ADR_NORMAL: 'NORMAL',

    // HK divisions
    HK_NUSKIN_DIVISION: '00',
    HK_PHARMANEX_DIVISION: '01',

    // HK contract lengths
    HK_6_MONTH_CD: 'n06',
    HK_18_MONTH_CD: 'n18',
    HK_ageLoc_Loyalty: 'w18',
    HK_6_MONTH: '6',
    HK_18_MONTH: '18',

    // contract types (mainly for HK)
    PHARMANEX: 'A',
    NUSKIN: 'P',
    HK20: 'N',
    UNKNOWN: '',

    // from config
    ADR_MODE: 'adrMode',
    CAN_SHIP_FUTURE: 'canShipFuture',
    SHOW_CONTRACT_LENGTHS: 'showContractLengths',
    FUTURE_DATES_NEXT_MONTH: 'futureDatesNextMonth',
    ALLOW_SI_RECURRING_DATE_CHANGE: 'allowShipImmediateRecurringDateChange',
    USE_DFLT_FOR_IMMEDIATE_FIRST: 'useDfltForShipImmediateFirst',
    USE_DFLT_FOR_IMMEDIATE_RECUR: 'useDfltForShipImmediateRecur',
    SHIP_ALWAYS_WITH_ASSESSMENT: 'shipAlwaysWithAssessment',
    SHIP_ALWAYS_WITH_CALIBRATION: 'shipAlwaysWithCalibration',
    IMMEDIATE_FUTURE: 'immediateFuture',   // matches dialog option
    DEFAULT_ALWAYS: 'defaultAlways',       // matches dialog option
    IMMEDIATE_ONLY: 'immediateOnly',       // matches dialog option
    BASIC_OPTIONS: 'basicOptions',         // used to just get get settings from the properties

    // ADR types
    IMMEDIATE: {value: 'immediate', isImmediate: true},
    FUTURE: {value: 'future', isImmediate: false},
    DEFAULT: {value: 'default', isImmediate: false},
    ALWAYS: {value: 'always', isImmediate: true},
    BASIC: {value: 'basic', isImmediate: true},

    // adrOptions keys
    ADR_TYPE: 'adrType',
    AVAILABLE_SHIP_DATES: 'availableShipDates',
    CART: 'cart',
    CONTRACT_LENGTH: 'contractLength',
    CONTRACT_LENGTHS: 'contractLengths',
    CONTRACT_TYPE: 'contractType',
    COUNTRY: 'country',
    DFLT_RECURRING_DT: 'defaultRecurringDate',
    LANG: 'language',
    MONTH_TEXT: 'monthText',
    NEXT_SHIP_DATE: 'nextShipDate',
    QUALIFIER: 'qualifier',

    SHOW_OPTIONAL_TEXT: 'showOptionalTxt',
    TODAY: 'today',
    TYPE: 'type'
};

export default AdrConstants;